import styles from "./toolbar-unselected-element.module.css";

interface ToolboxUnselectedElementProps {
  title: string;
  body: string;
}

export const ToolboxUnselectedElement = (
  props: ToolboxUnselectedElementProps
) => {
  return (
    <div className={styles.container}>
      <h1>{props.title}</h1>
      <p>{props.body}</p>
    </div>
  );
};
